import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PageHeader, Field, SimpleSelect, Table, Th, Td, Tr, Empty } from "@/components/common";
import { useApi, act } from "@/lib/useApi";
import { api } from "@/lib/api";
import { dtTime, ROLE_LABEL } from "@/lib/fmt";
import { useAuth } from "@/context/AuthContext";

export default function Users() {
  const { user: me } = useAuth();
  const [users, reload] = useApi("/users");
  const [students] = useApi("/students");
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ role: "professor" });
  const P = (k) => (e) => setF({ ...f, [k]: e?.target ? e.target.value : e });
  const save = async () => {
    const body = { name: f.name, email: f.email, password: f.password, role: f.role, student_id: f.role === "aluno" ? f.student_id : null,
      student_ids: f.role === "responsavel" && f.student_id ? [f.student_id] : [], permissions: f.role === "professor" ? { graduacao: f.grad !== false, checkin: true } : {} };
    const r = await act(() => api.post("/users", body), "Usuário criado");
    if (r) { setOpen(false); setF({ role: "professor" }); reload(); }
  };
  const patch = async (u, body, msg) => { await act(() => api.patch(`/users/${u.id}`, body), msg); reload(); };
  const resetLink = async (u) => {
    const r = await act(() => api.post(`/users/${u.id}/reset-link`));
    if (r) window.prompt("Envie este link ao usuário (válido por 60 minutos):", window.location.origin + r.path);
  };
  return (
    <div>
      <PageHeader eyebrow="Acessos" title="Usuários e permissões">
        <Button className="bg-red-600 hover:bg-red-700" onClick={() => setOpen(true)} data-testid="new-user-btn"><Plus className="w-4 h-4 mr-1" />Novo usuário</Button>
      </PageHeader>
      <div className="panel">{!users ? <Empty text="Carregando…" /> : <Table testid="users-table">
        <thead><tr><Th>Nome</Th><Th>E-mail</Th><Th>Perfil</Th><Th>Pode graduar</Th><Th>Último acesso</Th><Th>Ativo</Th><Th></Th></tr></thead>
        <tbody>{users.map((u) => <Tr key={u.id} testid={`user-row-${u.id}`}>
          <Td className="font-semibold">{u.name}</Td><Td>{u.email}</Td><Td>{ROLE_LABEL[u.role]}</Td>
          <Td>{u.role === "professor" ? <Switch checked={u.permissions?.graduacao !== false} onCheckedChange={(v) => patch(u, { permissions: { ...u.permissions, graduacao: v } }, "Permissão atualizada")} data-testid={`perm-grad-${u.id}`} /> : "—"}</Td>
          <Td className="text-xs">{dtTime(u.last_login)}</Td>
          <Td><Switch checked={u.active} disabled={u.id === me.id} onCheckedChange={(v) => patch(u, { active: v }, v ? "Usuário ativado" : "Usuário desativado")} data-testid={`active-${u.id}`} /></Td>
          <Td><Button size="sm" variant="ghost" onClick={() => resetLink(u)} data-testid={`reset-link-${u.id}`}>Link de senha</Button></Td>
        </Tr>)}</tbody></Table>}</div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="user-dialog">
          <DialogHeader><DialogTitle className="font-display text-2xl uppercase">Novo usuário</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <Field label="Perfil"><SimpleSelect value={f.role} onChange={P("role")} testid="user-role-select" options={Object.entries(ROLE_LABEL).map(([value, label]) => ({ value, label }))} /></Field>
            <Field label="Nome"><Input onChange={P("name")} data-testid="user-name-input" /></Field>
            <Field label="E-mail"><Input type="email" onChange={P("email")} data-testid="user-email-input" /></Field>
            <Field label="Senha inicial (mín. 8)"><Input type="password" onChange={P("password")} data-testid="user-password-input" /></Field>
            {["aluno", "responsavel"].includes(f.role) && <Field label="Aluno vinculado"><SimpleSelect value={f.student_id} onChange={P("student_id")} testid="user-student-select"
              options={(students || []).map((s) => ({ value: s.id, label: s.full_name }))} /></Field>}
            {f.role === "professor" && <label className="flex items-center gap-2 text-sm"><Switch checked={f.grad !== false} onCheckedChange={P("grad")} />Pode registrar graduações</label>}
            <Button onClick={save} className="w-full bg-red-600 hover:bg-red-700" data-testid="user-save-btn">Criar</Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
